import type { ValidationResult } from 'joi';

import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { UserRequestName } from '../../../user-request-name';
import { UserResponse } from '../../generic/user-response/user-response';
import { UserResponseSchema } from '../../generic/user-response/user-response-schema';

import { UserResponseCreateUserConstructor } from './user-response-create-user-constructor';
import { UserResponseCreateUserSchema } from './user-response-create-user-schema';

export class UserResponseCreateUser extends UserResponse<string> {
  protected userId?: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: UserResponseCreateUserConstructor) {
    super({
      ...parameters,
      [UserResponseSchema.type]: UserRequestName.createUser,
    });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: ValidationResult): UserResponseCreateUser {
    return new UserResponseCreateUser(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new UserResponseCreateUserSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(UserResponseCreateUser.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getUserId() {
    return this.userId;
  }
}
